<template lang="html">
  <section id="podcast" class="no-pad">
    <h1 class="no-pad">{{ podcasts.title }}</h1>
    <div class="aha-podcast">
      <div class="aha-row" v-for="(podcast, key) in podcasts.podcastlinks" :key="'p-' + key">
        <a :href="podcast.url" target="_blank">{{ podcast.title }}</a>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  computed: {
    podcasts() {
      return this.$store.getters.getPageByUID('podcast')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
